<template>
  <v-app>
    <div id="main">
      <div id="header">
        <div id="title"> READ-URBAN </div>
        <div id="subTitle"> Robust Estimation Using Agggregated Data for Urban Policy </div>
        <div id="loadingData">
          <span v-if="loadingData">
            {{ labels['loadingData'][currentLanguage] }}
            <v-icon color="#1976d2">fas fa-circle-notch fa-spin</v-icon>
          </span>
        </div>
        <div id="gemeenteSelection">
          <v-select v-if="labels"
            :items="gemeenten"
            item-text="name"
            :label="labels['gemeenteSelection'][currentLanguage]"
            :return-object="true"
            v-model="gemSelection"
            @change="onGemSelectionClick()">
          </v-select>
        </div>
        <div id="languageSelection"> <LanguageSelection /> </div>
      </div>
      <v-divider></v-divider>

      <div id="body">
        <div id="view-selection"> <ViewSelection /> </div>
        <div id="details-and-graphs">
          <div id="details"> <Details /> </div>
          <div id="graphs">
            <div id="scatterplot"> <Scatterplot /> </div>
            <div id="map"> <Map /> </div>
          </div>
        </div>
      </div>
      <v-divider></v-divider>
      <div id="description">
        <ProjectDescription />
      </div>
    </div>
  </v-app>
</template>


<style>
  body, html {
    height: 100%;
    /*overflow: hidden;*/
  }
  #main {
    height: 100%;
    display: flex;
    flex-direction: column;
    margin: 10px;
  }
  #header {
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }
  #title {
    flex: 0 0 auto;
    font-size: 20pt;
    font-weight: bolder;
    margin-right: 20px;
  }
  #subTitle {
    flex: 1 1 auto;
  }
  #loadingData {
    flex: 0 0 auto;
    margin-right: 40px;
  }
  #gemeenteSelection {
    flex: 0 0 auto;
    margin-right: 20px;
  }
  #languageSelection {
    flex: 0 0 auto;
    float: right;
  }
  #body {
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    height: 100%;
  }
  #view-selection {
    flex: 0 0 250px;
    overflow: auto;
  }
  #details-and-graphs {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
  }
  #details {
    flex: 0 0 80px;
  }
  #graphs {
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
  }
  #scatterplot {
    flex: 1 1 50%;
  }
  #map {
    flex: 1 1 50%;
  }
  #description {
    margin: 25px;
    min-height: 100px;
  }


</style>
<script>
import ViewSelection from './components/ViewSelection';
import Scatterplot from './components/Scatterplot';
import Map from './components/Map';
import Details from './components/Details';
import ProjectDescription from './components/ProjectDescription';
import LanguageSelection from './components/LanguageSelection';

export default {
  name: 'App',
  components: {
    ViewSelection,
    Scatterplot,
    Map,
    Details,
    ProjectDescription,
    LanguageSelection
  },
  data: () => ({
    gemSelection: null
  }),
  created: function () {
    this.$store.dispatch('init');
  },
  computed: {
    labels() {
      return this.$store.getters.labels;
    },
    currentView() {
      return this.$store.getters.currentView;
    },
    currentLanguage() {
      return this.$store.getters.currentLanguage;
    },
    gemeenten() {
      return this.$store.getters.gemeenten;
    },
    selectedGemeente() {
      return this.$store.getters.selectedGemeente;
    },
    loadingData() {
      return this.$store.getters.loadingData;
    }
  },
  methods: {
    onGemSelectionClick() {
      this.$store.commit('SET_SELECTED_GEMEENTE', this.gemSelection);
      this.$store.dispatch('readGemeenteData', this.gemSelection);
    }
  },
  watch: {
    selectedGemeente() {
      this.gemSelection = this.selectedGemeente;
    }
  }
};
</script>
